<template>
    <Layout :style="{paddingLeft: '370px'}">
        <Layout
            :style="{
              position: 'fixed', left: 0, top: '64px', width: '220px', bottom: '0px', 
              overflowYX: 'scroll'
            }"
        >
            <Sider
                hide-trigger
                :style="{overflowY: 'scroll', 'padding-left': '5px', 'padding-right': '5px', minWidth: '370px', backgroundColor: '#eee', borderRightx: '1px solid #DCDEE2'}"
            >
                <Card style="width: 100%" shadowx >
					<div slot="title" style="height: 20px;">
						<p >MENU</p>
					</div>
                    
                    <!-- <p>Please select folder below</p> -->
                    <Tree :data="$store.state.playlist" @on-select-change="onSelect"></Tree>
                </Card>

                <!-- <Menu
          ref="menu"
          :active-name="$store.state.path"
          theme="dark"
          width="auto"
          :style="{height: '100%'}"
          @on-select="onSelect"
        >
          <MenuGroup title="PLAYLIST">
               <Tree :data="$store.state.playlist"></Tree>
          </MenuGroup>
                </Menu>-->
            </Sider>
        </Layout>

        <Content
            :style="{ backgroundColor: '#eee', minHeightx: '600px', width: '100%', marginTop: '64px', marginBottomXXXForFotter: '100px', 'padding-right': '5px', paddingx: '20px 25px'}"
        >
            <Playlist></Playlist>
        </Content>
    </Layout>
</template>

<script>
import Playlist from "../components/Playlist.vue";

export default {
    components: {
        Playlist
    },
    methods: {
        onSelect(item) {
            //   console.log(item);
            if (item.length > 0) {
                this.$store.state.path = item[0].path;
            }
        }
    },
    mounted() {
        // this.$nextTick(() => {
        // console.log(this.$store.state.path)
        // this.$store.state.path = 'iklan'
        // this.$refs.menu.updateActiveName();
        // })
    }

    //   data() {
    //     return {
    // 		playlist: []
    //     }
    //   }
    //   computed: {
    //     playlistx() {
    //       return this.$store.state.playlist;
    //     }
    //   }
};
</script>